<template>
  <div class="dealing-mechanism">
    <header-title
      title="آلية التعامل مع وكالات الأمم المتحدة"
      titlePrevious="الرئيسية"
      color="#164e63"
    />
    <div class="container">
      <div class="mt-5">
        <h4 class="mt-2">أهداف الآلية:</h4>
        <ul class="mt-2">
          <li class="list_style_disc">
            تحقيق أوسع مشاركة للجمعيات في تنفيذ مشاريع بالتعاون مع وكالات الأمم
            المتحدة.
          </li>
          <li class="list_style_disc">
            تحقيق المرونة والسرعة والإجراءات المبسطة في دراسة مشاريع التعاون
            المقدمة.
          </li>
          <li class="list_style_disc">
            توفير إطار أكثر وضوحاً وتنظيماً لدراسة الطلبات ومعالجتها يلبي
            الاحتياجات الفنية في القطاعات وشفافية الإجراءات.
          </li>
        </ul>
      </div>

      <div>
        <h4 class="mt-2">
          الأسس التي يقوم عليها تعاون الجمعيات الأهلية مع المنظمات الدولية وفقاً
          للآلية المطورة:
        </h4>
        <ul class="mt-2">
          <li class="list_style_disc">
            تحقيق سلامة إجراءات التعاون ومساراته وضبطه خلال جميع مراحله بمشاركة
            جميع الجهات ذات الصلة، مع توفير الحد الأقصى من سهولة الإجراءات وسرعة
            إنجازها.
          </li>
          <li class="list_style_disc">
            توافق مشاريع التعاون مع الاعتبارات الوطنية والأولويات الفنية في جميع
            القطاعات.
          </li>
          <li class="list_style_disc">
            دراسة التعاون على أساس مضمون المشروع وليس على أساس قائمة محددة
            للجمعيات. وبالتالي سيكون مسموحاً لأي جمعية أو مؤسسة أهلية مشهرة
            وفقاً لقانون الجمعيات والمؤسسات الأهلية رقم /93/ لعام 1958 بتنفيذ
            مشاريع تعاون مع وكالات الأمم المتحدة،
          </li>
          <li class="list_style_disc">
            يعتمد لكل مشروع من مشاريع التعاون بين الجمعيات الأهلية ووكالات الأمم
            المتحدة رقم تعريفي من قسمين:
            <ul>
              <li class="list_style_disc">قسم يتضمن الرقم التسلسلي (#)</li>
              <li class="list_style_disc">
                قسم يضمن ترميز المشروع (رمز محافظة المقر/ رمز محافظة التنفيذ/
                رمز المنظمة)
              </li>
            </ul>
          </li>
          <li class="list_style_disc">
            يقدم الطلب وفق استمارة معتمدة تتضمن جميع المعلومات والتفاصيل الفنية
            الخاصة به مع المرفقات التالية:
            <ul>
              <li class="list_style_disc">نموذج استمارة مطابقة الوثائق</li>
              <li class="list_style_disc">
                نموذج قائمة أرقام الاتصال مع الجمعية
              </li>
              <li class="list_style_disc">نموذج استمارة طلب تنفيذ المشروع</li>
              <li class="list_style_disc">نموذج تفويض لمندوب الجمعية</li>
              <li class="list_style_disc">
                نموذج تفويض التوقيع نيابة عن رئيس مجلس الإدارة
              </li>
              <li class="list_style_disc">
                نموذج تعهد الجمعية بالالتزام بشفافية توفير بيانات المشروع
              </li>
              <li class="list_style_disc">نموذج نشرة الاستعلامات</li>
              <li class="list_style_disc">
                اتفاق المشروع موقعاً من طرف وكالة الأمم المتحدة فقط
              </li>
            </ul>
          </li>
          <li class="list_style_disc">
            تعتمد 7 معايير لدراسة طلبات تعاون الجمعيات ووكالات الأمم المتحدة تتم
            دراسة طلبات الجمعيات بناءً عليها، وتتحقق كل جهة من المعايير المتعلقة
            بدورها واختصاصها وتعطى موافقتها بناءً على ذلك.
          </li>
          <li class="list_style_disc">
            تكون الموافقة على طلبات تنفيذ المشاريع بناءً على تحقيق المشروع لجميع
            المعايير المعتمدة، وخلال مدة /30/ يوماً في حال كانت جميع الوثائق
            مطابقة للنماذج المعتمدة، والمضمون الفني للمشروع متوافق مع المعايير
            المعتمدة.
          </li>
          <li class="list_style_disc">
            لا تعتبر ا لا يعتبر اتفاق أي مشروع نافذاً ولا يسمح بمباشرة أية أعمال
            بموجبه قبل منح الموافقة وتوقيع الاتفاق من قبل وزير الشؤون الاجتماعية
            والعمل أو المحافظ المعني نيابة عنه. وتعتبر أية أعمال تنفذ من قبل
            الجمعية دون الموافقة على المشروع مخالفة تعرضها للمساءلة القانونية.
          </li>
        </ul>
      </div>
      <div class="d-flex justify-content-end my-2">
        <b-button variant="primary">
          <feather-icon
            size="1.5x"
            icon="DownloadIcon"
            class="custom-class mr-1"
          ></feather-icon>
          <a
            href="/files/dealing-mechanism.docx"
            download
            class="download_button"
            >تحميل دليل آلية التعامل مع وكالات الأمم المتحدة</a
          >
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import { BButton } from "bootstrap-vue";
export default {
  components: { HeaderTitle, BButton },
};
</script>

<style lang="scss" scoped>
.dealing-mechanism {
  .download_button {
    color: #ffffff;
    margin-right: 5px;
  }
}

p,
ul {
  text-align: justify;
  font-size: 16px;
  line-height: 28px;
  font-family: "Lato", sans-serif;
  margin: 10px 0px;
}
h2 {
  margin-bottom: 1rem;
  font-size: 32px;
}
</style>
